import {TiposMutationLoading} from './tipos-mutation.loading';
import {MapActionsLoading} from './map-actions.loading';

export default {
    namespaced: true,
    state: () => ({
        showLoading: false,
    }),
    mutations: {
        // @ts-ignore
        [TiposMutationLoading.SET_SHOW](state: any, showLoading: boolean) {
            state.showLoading = showLoading;
        }
    },
    actions: {
        // @ts-ignore
        [MapActionsLoading.OPEN_LOADING]({commit}) {
            commit(TiposMutationLoading.SET_SHOW, true);
        },
        // @ts-ignore
        [MapActionsLoading.CLOSE_LOADING]({commit}) {
            commit(TiposMutationLoading.SET_SHOW, false);
        },
    },
    getters: {
        showLoading: (state: any) => state.showLoading,
    }
};
